import React, { useState, useEffect } from "react";
import { Box, Container, Typography } from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import homepageHeader from "../images/product-img-5.png";

// Animations
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Styled Components
const HeroContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
  minHeight: "90vh",
  [theme.breakpoints.down('md')]: {
    minHeight: "85vh",
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: "80vh",
  },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundImage: `url(${homepageHeader})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    background: "linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.7) 100%)",
    pointerEvents: "none",
  },
}));

const GridPattern = styled(Box)({
  position: "absolute",
  inset: 0,
  opacity: 0.03,
  backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
                     linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px)`,
  backgroundSize: "50px 50px",
  pointerEvents: "none",
  zIndex: 1,
});

const ContentBox = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 2,
  textAlign: "center",
  padding: "80px 24px",
  [theme.breakpoints.down('md')]: {
    padding: "60px 20px",
  },
  [theme.breakpoints.down('sm')]: {
    padding: "40px 16px",
  },
}));

function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);
  }, []);

  return (
    <HeroContainer>
      <GridPattern />
      
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 } }}>
        <ContentBox>
          {/* Subtitle */}
          <Box
            sx={{
              mb: { xs: 1.5, sm: 2 },
              animation: isVisible ? `${fadeIn} 0.8s ease-out 0.2s both` : "none",
            }}
          >
            <Typography
              variant="overline"
              sx={{
                color: "#c1e328",
                fontWeight: 600,
                letterSpacing: { xs: 2, sm: 3 },
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              }}
            >
              Robotic Mobility Solutions
            </Typography>
          </Box>

          {/* Main Title */}
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "2.5rem", sm: "4.5rem", md: "5.5rem" },
              fontWeight: 900,
              mb: { xs: 2, sm: 2.5 },
              letterSpacing:1,
              lineHeight: 1.1,
              fontFamily: "'Avenir Next Condensed Heavy', 'Avenir Next Condensed Extra Bold', 'Avenir Next Condensed', 'Arial Black', sans-serif",
              animation: isVisible ? `${fadeInUp} 0.8s ease-out 0.4s both` : "none",
              textShadow: "0 2px 30px rgba(0, 0, 0, 0.3)",
              color: "#fff",
            }}
          >
            AUTOMIST500x
          </Typography>
            
          {/* Description */}
          <Typography
            variant="h5"
            sx={{
              mb: { xs: 3, sm: 4 },
              color: "rgba(255, 255, 255, 0.85)",
              maxWidth: 600,
              mx: "auto",
              lineHeight: 1.6,
              fontSize: { xs: "1rem", sm: "1.125rem", md: "1.375rem" },
              fontWeight: 400,
              animation: isVisible ? `${fadeInUp} 0.8s ease-out 0.6s both` : "none",
            }}
          >
            Delivered with precision and innovation
          </Typography>
        </ContentBox>
      </Container>
    </HeroContainer>
  );
}

export default HeroSection;
